<template>
  <router-link
    :to="`conseiller/${data.fields.slug}`"
    class="conseil-content">
    <div><img
      :src="`${data.fields.menuPicture.fields.file.url}?q=80`"
      alt=""></div>
    <div class="conseil-desc">{{ data.fields.title }}</div>
  </router-link>
</template>

<script>
export default {
  name: "ConseillerItem",
  props: {
    data: {
      type: Object
    }
  }
};
</script>

<style scoped>
.conseil-content {
  width: 200px;
  margin: 1em;
  transition: 0.2s ease-in;
  text-decoration: none;
  box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
}
.conseil-content:hover {
  cursor: pointer;
  box-shadow: 0 4px 10px 0 rgba(194, 194, 194, 0.9);
}
img {
  height: 150px;
  width: 200px;
  object-fit: cover;
}

.conseil-desc {
  padding: 1em;
  color: #4a4a4a;
  text-decoration: none;
}
</style>
